<div
  [innerHTML]="
    'EntertainmentAPIErrorComponent:ReserveTicketMessage'
      | translate
        : {
            generalContactNumber: (customisableVariables | async).contact_number_general,
            generalContactNumberHidden: (customisableVariables | async).contact_number_general ? '' : 'hidden',
            separatorHidden:
              (customisableVariables | async).contact_number_general &&
              (customisableVariables | async).toll_free_contact_number
                ? ''
                : 'hidden',
            tollFreeContactNumber: (customisableVariables | async).toll_free_contact_number,
            tollFreeContactNumberHidden: (customisableVariables | async).toll_free_contact_number ? '' : 'hidden'
          }
  "
></div>
